<template>
    <div style="min-height: calc(100vh - 70px);display: flex;">
        <section v-if="step===1" class="m-content m-content-full align-items-center forget">
            <div class="gate_center col">
                <div class="row  justify-content-center">
                    <div class="card col-12 col-md-8 col-lg-5 text-center">
                        <div class="card__title text-center">
                            <h3>Reset PIN!</h3>
                            <p class="text-center input--hint"> Please provide the following details below as we
                                help you get a new PIN</p>
                        </div>
                        <div class="card__body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="material--input--group">
                                        <input type="text"
                                               v-ep-restrict.number
                                               class="phone"
                                               maxlength="11" title="Phone number" name="phone"
                                               v-model="phonenumber"
                                               required>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <div
                                            :class="`vuelidate-error ${$v.phonenumber.$invalid ? 'vuelidate-error-show' : 'vuelidate-error-hide'}`"
                                        >
                                            <div v-if="!$v.phonenumber.required">Phone number is required.</div>
                                            <div
                                            v-if="!$v.phonenumber.minLength"
                                            >Please enter an 11 digit phone number.</div>
                                        </div>
                                        <label for="first_name">Phone number</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <Datepicker wrapper-class="material--input--group"
                                                format="yyyy-MM-dd"
                                                :disabledDates="disabledDates" v-model="dobdt" name="dobdt"
                                                id="dobdt"
                                                v-ep-restrict.readonly
                                                class="dob"
                                                :typeable="true"
                                                :required="true">
                                        <span slot="afterDateInput" class="highlight"></span>
                                        <span slot="afterDateInput" class="bar"></span>
                                        <label slot="afterDateInput">Date of birth</label>
                                    </Datepicker>
                                    <div
                                    :class="`vuelidate-error ${$v.dobdt.$invalid ? 'vuelidate-error-show' : 'vuelidate-error-hide'}`"
                                    >
                                    <div v-if="!$v.dobdt.required">Date of birth is required.</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="material--input--group">
                                        <input type="text"
                                               v-ep-restrict.number
                                               maxlength="11" title="Bank Verification Number (BVN)" name="bvn"
                                               class="bvn"
                                               v-model="bvn" required>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <div
                                            :class="`vuelidate-error ${$v.bvn.$invalid ? 'vuelidate-error-show' : 'vuelidate-error-hide'}`"
                                        >
                                            <div v-if="!$v.bvn.required">BVN is required.</div>
                                            <div v-if="!$v.bvn.minLength">Please enter an 11 digit number.</div>
                                        </div>
                                        <label for="bvn">Bank Verification Number (BVN) </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card__footer">
                            <button type="button" @click="forget()"
                                    :disabled="$v.phonenumber.$invalid || $v.bvn.$invalid || $v.dobdt.$invalid || is_submiting"
                                    class="btn m-btn--square btn-block btn-primary btn-lg m-btn wizard-next">
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="step===2" class="m-content m-content-full align-items-center">
            <div class="gate_center col">
                <div class="row  justify-content-center">
                    <div class="card col-12 col-md-8 col-lg-5">
                        <div class="card__title">
                            <h3 class="text-center">Reset your Carbon PIN</h3>
                            <p class="input--hint">Please create a 4 digit PIN which you will use to access your
                                Carbon account. Please keep this PIN secure and do not disclose it to anyone</p>
                        </div>
                        <create-confirm-pin :callback='reset' ref='forgetResetPin' />
                        <div class="card__footer">
                            <form v-on:submit.prevent="reset">
                                <button type="submit" :disabled="is_submiting"
                                        class="btn m-btn--square btn-block btn-primary btn-lg m-btn">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="m-gate_bg gate-full gate_bg_not_mobile">
            <img src="./../../../static/media/demo/default/img/misc/forget_bg.png" alt="">
        </div>
        <div class="m-gate_bg gate_bg_only_mobile ">
            <img src="./../../../static/media/demo/default/img/misc/forget_bg-mobile.png" alt="">
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import createConfirmPin from "../../components/createConfirmPin";
    import InputFilter from './../../filters/Input';
    import {postForget, postReset} from './../../api/user/userService'
    import { required } from "vuelidate/lib/validators";
    import { phoneNumberValidator, bvnValidator } from "../../utils/inputValidators";

    InputFilter()

    export default {
        mounted() {
            this.$store.dispatch('logout')
            $('body').addClass('m--bg-white').removeClass('m-content--skin-light2')
            $('.m-brand--skin-light').removeClass('m-brand--skin-light2')
            $('.m-stack__item.m-brand.m-brand--skin-light').removeClass('m-brand--skin-light')
        },
        components: {
            Datepicker,
            createConfirmPin,
        },
        data: () => ({
            step: 1,
            is_submiting: false,
            disabledDates: {
                from: new Date()
            },
            dobdt: null,
            phonenumber: null,
            bvn: null,
        }),
        validations: {
            phonenumber: {
                ...phoneNumberValidator
            },
            bvn: {
                ...bvnValidator
            },
            dobdt: {
                required
            },
        },
        methods: {
            forget() {
                this.is_submiting = true

                const isFormInValid = this.$v.phonenumber.$invalid || this.$v.bvn.$invalid || this.$v.dobdt.$invalid;
                if (isFormInValid) {
                    this.$swal({
                        title: 'error',
                        imageUrl: "/images/svg/Error.svg",
                        title: "Form is broken"
                    });
                    this.is_submiting = false
                    return
                }

                let _data = {
                    "bvn": this.bvn,
                    "dob": moment(this.dobdt).format('YYYY-MM-DD'),
                    "phonenumber": this.phonenumber
                }
                this.$store.dispatch('loader', true)
                postForget(_data).then(response => {
                    if (response.response.data !== undefined) {
                        let authToken = response.response.data.authToken
                        this.$store.dispatch('saveToken', {"token": authToken, "phonenumber": this.phonenumber})
                        this.step++
                    }
                }).catch(error => {
                    this.$store.dispatch('handleError', {
                        response: error,
                        callback: this.forget,
                        can_cancel: true
                    })
                }).finally(() => {
                    this.$store.dispatch('loader', false)
                    this.is_submiting = false
                })
            },
            reset() {
                if (this.$refs.forgetResetPin.confirmPins()){
                    let pin = this.$refs.forgetResetPin.pincodes.join("")
                    this.is_submiting = true;
                    postReset(pin).then(response => {
                        if (response.response.data !== undefined) {
                            this.$store.dispatch('logout')
                            let can_cancel = false
                            this.$swal({
                                    type: 'success',
                                    allowEscapeKey: can_cancel,
                                    confirmButtonText: 'Go to Login',
                                    allowOutsideClick: can_cancel,
                                    title: "PIN updated successfully"
                                }
                            ).then((result) => {
                                if (result.value) {
                                    this.$store.dispatch('redirect', 'login')
                                }
                            })
                        }
                    }).catch(error => {
                        this.$store.dispatch('handleError', {
                            response: error,
                            callback: this.reset,
                            can_cancel: true
                        })
                    }).finally(() => {
                        this.$store.dispatch('loader', false)
                        this.is_submiting = false
                    })
                } else {
                    this.$refs.forgetResetPin.resetCC()
                    this.$swal({
                        imageUrl: "/images/svg/Error.svg",
                        title: 'Your PINs do not match. Please try again.',
                    });
                }
            }
        }
    };
</script>

<style scoped>
    .vuelidate-error {
        text-align: left
    }
</style>
